<template>
  <div
    v-if="picturesProxy.length"
    class="flex flex-row"
    style="flex-wrap: wrap;"
  >
    <van-image
      class="flex-auto"
      style="height: 178px; width: 178px;"
      v-for="(it, idx) in picturesProxy"
      :key="idx"
      :src="it"
      :preview-src-list="picturesProxy"
      fit="contain"
      @click="() => handlePreview(idx)"
    />
    <van-image-preview
      v-model="visible"
      :images="picturesProxy"
      :startPosition="index"
    />
  </div>
</template>
<script>
import vue from "vue";
import { Image, ImagePreview } from "vant";
import { assembleFileUrl } from "@/utils/LinkHelper";
vue.use(ImagePreview);
export default {
  name: "gallery-mobile",
  components: {
    [Image.name]: Image,
  },
  props: {
    pictures: {
      type: Array,
    },
  },
  data() {
    return {
      visible: false,
      index: 0,
    };
  },
  computed: {
    picturesProxy() {
      if (Array.isArray(this.pictures)) {
        return this.pictures.map((it) => assembleFileUrl(it));
      }
      return [];
    },
  },
  methods: {
    handlePreview(idx) {
      this.index = idx;
      this.visible = true;
    },
  },
};
</script>
